import { render, staticRenderFns } from "./AddPhysicalStorage.vue?vue&type=template&id=23b6beda&"
import script from "./addPhysicalStorageScript.js?vue&type=script&lang=js&"
export * from "./addPhysicalStorageScript.js?vue&type=script&lang=js&"
import style0 from "./addPhysicalStorage.less?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports